export const BENEFITS_MODAL = 'benefitsModal'
